import { getGrowthFeatureDefaults } from "./growth-feature-defaults-copy";

import type { CampaignAutomationDemoCopy } from "./CcCampaignAutomationDemo";

export type GrowthFeatureCampaignCardCopy = {
  title: string;
  description: string;
  badge: string;
  demo: CampaignAutomationDemoCopy;
};

export const DEFAULT_GROWTH_FEATURE_CAMPAIGN_COPY: GrowthFeatureCampaignCardCopy = getGrowthFeatureDefaults("en").campaign as GrowthFeatureCampaignCardCopy;
